module.exports = __webpack_public_path__ + "static/img/idn.6bb26dbf.png";